(function(){
  'use strict';
  var current = document.currentScript;
  if (!current || !current.src) return;

  function loadSibling(name, after) {
    var script = document.createElement('script');
    script.src = new URL(name, current.src).href;
    if (current.defer) script.defer = true;
    if (current.async) script.async = true;
    (after || current).parentNode.insertBefore(script, (after || current).nextSibling);
    return script;
  }

  var trustPatch = loadSibling('profind-dev-safe.js', current);
  var onboardingPatch = loadSibling('profind-optional-onboarding.js', trustPatch);

  if (/^\/pages\/profind-admin$/i.test(location.pathname)) return;

  loadSibling('profind-national-coverage-core.js', onboardingPatch);
})();
